"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _RidePaymentDetail = _interopRequireDefault(require("./RidePaymentDetail.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Container = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__Container",
  componentId: "sc-cujath-0"
})(["display:flex;padding:16px;justify-content:center;flex-direction:column;border:", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid ".concat(theme.borderRadius.normal);
});
var ListItem = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__ListItem",
  componentId: "sc-cujath-1"
})(["display:flex;justify-content:center;flex-direction:column;"]);
var ItemContainer = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__ItemContainer",
  componentId: "sc-cujath-2"
})(["display:flex;"]);
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__IconWrapper",
  componentId: "sc-cujath-3"
})(["padding-right:10px;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;"]);
var InfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__InfoWrapper",
  componentId: "sc-cujath-4"
})(["flex-direction:column;font-family:", ";width:100%;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
});
var ListHeader = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__ListHeader",
  componentId: "sc-cujath-5"
})(["font-weight:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.bold;
});
ListHeader.displayName = 'ListHeader';
var ListInfo = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__ListInfo",
  componentId: "sc-cujath-6"
})(["text-align:justify;font-size:", ";color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDark;
});
ListInfo.displayName = 'ListInfo';
var Separator = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__Separator",
  componentId: "sc-cujath-7"
})(["border-top:", ";margin:16px 0;"], function (_ref7) {
  var theme = _ref7.theme;
  return "1px solid ".concat(theme.colors.greyLight);
});
var LinkIcon = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__LinkIcon",
  componentId: "sc-cujath-8"
})(["background:", ";flex:1;width:2px;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyMedium;
});
var Label = _styledComponents.default.div.withConfig({
  displayName: "RidePaymentDetail__Label",
  componentId: "sc-cujath-9"
})(["font-family:", ";font-weight:", ";font-size:", ";margin-bottom:8px;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.bold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.normal;
});
var RidePaymentDetail = function RidePaymentDetail(props) {
  var customProperties = props.customProperties,
    accessible = props.accessible,
    theme = props.theme,
    data = props.data,
    headerTitle = props.headerTitle;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(data),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    dataState = _useState2[0],
    setData = _useState2[1];
  (0, _react.useEffect)(function () {
    setData(data);
  }, [data]);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Container, customProperties, /*#__PURE__*/_react.default.createElement(Label, null, headerTitle), /*#__PURE__*/_react.default.createElement(ListItem, null, !!(dataState !== null && dataState !== void 0 && dataState.length) && dataState.map(function (item, index, row) {
      return /*#__PURE__*/_react.default.createElement(ItemContainer, {
        key: "ride-".concat(item.title)
      }, item.icon && item.icon.icon && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
        accessible: accessible
      }, item.icon)), index + 1 !== row.length && /*#__PURE__*/_react.default.createElement(LinkIcon, null)), /*#__PURE__*/_react.default.createElement(InfoWrapper, null, /*#__PURE__*/_react.default.createElement(ListHeader, null, item.title), /*#__PURE__*/_react.default.createElement(ListInfo, null, item.info), index + 1 !== row.length && /*#__PURE__*/_react.default.createElement(Separator, null)));
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
RidePaymentDetail.propTypes = _RidePaymentDetail.default.PropTypes;
RidePaymentDetail.defaultProps = _RidePaymentDetail.default.DefaultProps;
var _default = RidePaymentDetail;
exports.default = _default;